module.exports = __webpack_public_path__ + "static/media/civic.15bb7bec.png";